const API_ROUTES = {
  login: '/auth/login',
  dashboard: '/dashboard',
  dashboardSummary: '/dashboard/summary',
  messageInbox: '/messageinbox',
  inquiryWorkflow: '/inquiry-workflow',
  assistant: '/assistant',
  whatsappBroadcasts: '/whatsapp-broadcasts',
};

export default API_ROUTES;
